module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workStatistics"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("班级作业报告")]), _vm._v(" "), _c('div', {
    staticClass: "contentReport"
  }, [_c('rankHeader', {
    attrs: {
      "classList": _vm.classList,
      "className": _vm.className,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate
    },
    on: {
      "changClassId": _vm.changClassId,
      "changedPicker": _vm.changedPicker,
      "getWorkStatistics": _vm.getWorkStatistics
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dataBox"
  }, [_c('div', {
    staticClass: "basicInfo"
  }, [_c('span', {
    staticClass: "tip"
  }, [_vm._v("基本情况")]), _vm._v(" "), _c('table', [_c('tr', [_c('th', [_vm._v("布置作业次数")]), _vm._v(" "), _c('th', [_vm._v("平均提交率")]), _vm._v(" "), _c('th', [_vm._v("平均作业时长")]), _vm._v(" "), _c('th', [_vm._v("\n            平均成绩\n            "), _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": "200",
      "trigger": "hover",
      "content": "一段时间内，班级平均得分，换算成百分制。"
    }
  }, [_c('i', {
    staticClass: "iconQMark",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.classBaseInfo.assignNum))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("toPercent")(_vm.classBaseInfo.avgFinishRate, 2, '-')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("secTotime1")(_vm.classBaseInfo.avgWorkTime)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.classBaseInfo.score))])])])]), _vm._v(" "), _c('echartLine', {
    attrs: {
      "echartData": _vm.echartData
    },
    on: {
      "setsoreType": _vm.setsoreType
    }
  }), _vm._v(" "), _c('reportTable', {
    attrs: {
      "userList": _vm.userList,
      "worklist": _vm.workList,
      "url": _vm.exportUrl
    }
  }), _vm._v(" "), _c('scoreTable', {
    attrs: {
      "scoreData": _vm.scoreData,
      "url": _vm.exportClassWorkUrl
    },
    on: {
      "setPage": _vm.setPage
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0768b8b5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/classReport.vue
// module id = 1157
// module chunks = 1